import { render, staticRenderFns } from "./SimpleUploader.vue?vue&type=template&id=2c2ab696&"
import script from "./SimpleUploader.vue?vue&type=script&lang=js&"
export * from "./SimpleUploader.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUploader.vue?vue&type=style&index=0&id=2c2ab696&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports